var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { loadFbpScript, loadGAScript, loadTtqScript } from './loadScipts';
import { SellerPortalHostMap } from '@/constants';
const langMap = {
  'zh-CN': 'zh-Hans'
};
let bannerTask;
let currentLocale = '';
let optionalScriptsLoaded = false;

const initializeBanner = locale => __awaiter(void 0, void 0, void 0, function* () {
  // Load browser SDKs after hydration, not while rendering the page on the server.
  const [{
    default: cookieBanner
  }, {
    TtWid
  }] = yield Promise.all([import('@tiktok-fe/web-cookie-banner'), import('@byted-ucenter/ttwid/lib/pure')]);
  const apiDomain = window.location.origin;

  try {
    const webId = new TtWid({
      aid: APP_ID,
      service: window.location.hostname,
      unionHost: apiDomain,
      timeout: 5000
    }); // checkWebId also registers an ID when the existing cookie is absent/invalid.

    const result = yield webId.checkWebId();

    if ((result === null || result === void 0 ? void 0 : result.status_code) !== 0) {
      console.error('Cookie banner: ttwid registration did not succeed.');
    }
  } catch (_a) {
    // Still display the notice if identity registration is temporarily unavailable.
    console.error('Cookie banner: unable to initialize ttwid.');
  }

  yield cookieBanner.loadCookieBanner({
    locale,
    apiDomain,
    consentApiDomain: apiDomain,
    onConsentGet: consent => {
      const isZH = window.location.hostname === SellerPortalHostMap.zh;

      if (isZH || !consent.optional || optionalScriptsLoaded) {
        return;
      }

      optionalScriptsLoaded = true;
      loadGAScript();
      loadFbpScript();
      loadTtqScript();
    }
  });
  return cookieBanner;
});

export const loadCookiebanner = lang => __awaiter(void 0, void 0, void 0, function* () {
  var _b;

  if (typeof window === 'undefined') {
    return;
  }

  const locale = (_b = langMap[lang]) !== null && _b !== void 0 ? _b : lang;

  try {
    // Several routes share this loader; the SDK only supports one initialization.
    if (!bannerTask) {
      currentLocale = locale;
      bannerTask = initializeBanner(locale);
    }

    const cookieBanner = yield bannerTask;

    if (currentLocale !== locale) {
      currentLocale = locale;
      yield cookieBanner.updateBannerLocale(locale);
    }
  } catch (_c) {
    console.error('Cookie banner: unable to load the consent banner.');
  }
});